import type { IConfig } from '@icecreamsocial/jssdk';
import { atom } from "jotai";
import { focusAtom } from 'jotai-optics';

export type SupplementaryData = {
	publicKey: string, 
	campaignId: string, 
	widgetLocation: string;
	/**
	 * @deprecated
	 * alias for `subtotal`.  included for backwards compatibility
	 */
	revenue: string,
	/**
	 * @deprecated
	 * alias for `mobileNumber`.  included for backwards compatibility
	 */
	phoneNumber: string; 
}
export interface ExtendedConfig extends IConfig {
	data: IConfig['data'] & SupplementaryData;
	/**
	 * an influencer id of an influencer previously created on the current domain
	 */
	_uid: string;
}
export type ICSVariables = {
	productName: string;
	productURL: string;
	promocode: string;
	metaPlatform: string;
	metaChannel: string;
	metaQuery: string;
		// variables that override internal fields such as utm params
	altSource: string;
	altMedium: string;
	altCampaign: string;
	altContent: string;
	altTerm: string;
	custom: CustomVariables;
};

/**
 * variables that are prefixed with "custom" will be able to be replaced
 */
export type CustomVariables = Record<string, string>;


export const configAtom = atom<Partial<ExtendedConfig>>({});

/**
 * gets the data layer of the config
 */

// @ts-expect-error the type checking for this goes crazy because it goes deep or something.
export const dataLayerAtom = focusAtom<Partial<ExtendedConfig['data']>, Partial<ExtendedConfig['data']>, Partial<ExtendedConfig['data']>>(configAtom, optic => optic.prop('data'));

/**
 * get the behavior of the config
 */
// @ts-expect-error the type checking for this goes crazy because it goes deep or something.
export const behaviorAtom = focusAtom<Partial<ExtendedConfig['behavior']>, Partial<ExtendedConfig['behavior']>, Partial<ExtendedConfig['behavior']>>(configAtom, optic => optic.prop('behavior'));

/**
 * get the theme of the config
 */
// @ts-expect-error the type checking for this goes crazy because it goes deep or something.
export const themeAtom = focusAtom<Partial<ExtendedConfig['theme']>, Partial<ExtendedConfig['theme']>, Partial<ExtendedConfig['theme']>>(configAtom, optic => optic.prop('theme'));

/**
 * get the variables of the config
 */
// @ts-expect-error the type checking for this goes crazy because it goes deep or something.
export const variablesAtom = focusAtom<Partial<ExtendedConfig['variables']>, Partial<ExtendedConfig['variables']>, Partial<ExtendedConfig['variables']>>(configAtom, optic => optic.prop('variables'));

/**
 * get the locale of the config
 */
// @ts-expect-error the type checking for this goes crazy because it goes deep or something.
export const localeAtom = focusAtom<typeof configAtom, Partial<ExtendedConfig['locale']>, Partial<ExtendedConfig['locale']>>(configAtom, optic => optic.prop('locale'));
